import React from 'react';

const DILetter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="193"
    height="96"
    viewBox="0 0 193 96"
    fill="none"
    {...props}
  >
    <path
      d="M66.7242 95.7162H62.5627C62.1171 95.7295 61.6742 95.6412 61.2678 95.4579C60.8613 95.2747 60.5019 95.0013 60.2167 94.6584C59.9316 94.3156 59.7281 93.9124 59.6219 93.4793C59.5156 93.0462 59.5093 92.5946 59.6035 92.1587L71.5757 20.7662C71.7646 19.7911 72.2781 18.9087 73.0325 18.2627C73.7868 17.6167 74.7376 17.2452 75.73 17.2087H179.269C179.714 17.1954 180.157 17.2838 180.564 17.467C180.97 17.6503 181.33 17.9237 181.615 18.2665C181.9 18.6093 182.103 19.0125 182.21 19.4456C182.316 19.8787 182.322 20.3303 182.228 20.7662L170.54 90.4938C170.265 91.9256 169.512 93.2216 168.404 94.1702C167.297 95.1187 165.901 95.6637 164.444 95.7162H66.7242Z"
      fill="#FCF6ED"
    />
    <path
      d="M170.45 50.678C182.904 50.678 193 40.5799 193 28.1233C193 15.6666 182.904 5.56854 170.45 5.56854C157.996 5.56854 147.9 15.6666 147.9 28.1233C147.9 40.5799 157.996 50.678 170.45 50.678Z"
      fill="#39C088"
    />
    <path
      d="M62.0518 36.7253L63.6239 26.565L110.673 55.7367C111.979 56.4732 113.455 56.853 114.953 56.838C116.451 56.823 117.92 56.4138 119.21 55.6514L148.831 39.9627"
      stroke="#48505C"
      strokeWidth="5.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M172.304 47.7893L166.613 83.1227C166.287 84.9416 165.347 86.5935 163.95 87.8029C162.553 89.0123 160.784 89.706 158.937 89.7682H60.5275C59.6917 89.7927 58.8611 89.6285 58.0974 89.2877C57.3338 88.9469 56.6568 88.4384 56.1167 87.7998C55.5767 87.1612 55.1876 86.4091 54.9783 85.5993C54.769 84.7896 54.7449 83.943 54.9078 83.1227L60.1932 48.757"
      stroke="#48505C"
      strokeWidth="5.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M64.9179 18.1556C65.2411 16.336 66.179 14.6826 67.5748 13.4717C68.9706 12.2608 70.7397 11.5658 72.5864 11.5031H148.119"
      stroke="#48505C"
      strokeWidth="5.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M130.211 60.3042L159.953 80.7315"
      stroke="#48505C"
      strokeWidth="5.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M99.0779 60.3042L63.0403 80.7315"
      stroke="#48505C"
      strokeWidth="5.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M73.3682 43.065H12.248"
      stroke="#48505C"
      strokeWidth="5.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M56.3522 33.815H3"
      stroke="#48505C"
      strokeWidth="5.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M53.5091 52.3144H21.8322"
      stroke="#48505C"
      strokeWidth="5.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.3716 61.5643H32.8762"
      stroke="#48505C"
      strokeWidth="5.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M166.414 48.1095C178.868 48.1095 188.964 38.0114 188.964 25.5547C188.964 13.0981 178.868 3 166.414 3C153.96 3 143.864 13.0981 143.864 25.5547C143.864 38.0114 153.96 48.1095 166.414 48.1095Z"
      stroke="#48505C"
      strokeWidth="5.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M153.181 27.8178L160.017 34.6625L177.637 17.0314"
      stroke="white"
      strokeWidth="5.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

DILetter.displayName = 'DILetter';

export default DILetter;
